// src/pages/Payments/Payments.js

import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { fetchPayments } from "../../redux/slices/paymentSlice";
import DataTableMUI from "../../components/common/DataTable";
import { useNavigate } from "react-router-dom";
import { PaymentColumns } from "../../services/tableColomn";

// Status filter options for the payments table
const statusOptions = [
  { label: "All", value: "all", color: "#2563eb" },
  { label: "Pending", value: "pending", color: "#f59e0b" },
  { label: "Success", value: "success", color: "#22c55e" },
  { label: "Failed", value: "failed", color: "#ef4444" },
  { label: "Cancelled", value: "cancelled", color: "#6b7280" },
];

const Payments = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Local state for controlling the table
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  // Select data from the Redux store
  const { payments, loading, statusCounts, pagination } = useAppSelector(
    (state) => state.payment
  );

  // useEffect to fetch data when any filter/pagination state changes
  useEffect(() => {
    dispatch(
      fetchPayments({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );
  }, [dispatch, statusFilter, page, search, itemsPerPage, sortKey, sortOrder]);

  // Handler functions
  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1); // Reset to first page on filter change
  };

  const handlePageChange = (newPage) => setPage(newPage);

  const handleView = (row) => {
    // Navigate to a details page or open a modal
    console.log("View payment details:", row);
    // navigate(`/payments/${row._id}`); // Example navigation
  };

  const handleSort = (col) => {
    if (!col.sortable) return;
    setSortKey(col.accessor);
    setSortOrder(
      sortKey === col.accessor && sortOrder === "asc" ? "desc" : "asc"
    );
    setPage(1);
  };

  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
  };

  // Add dynamic counts from API to the status options
  const statusOptsWithCounts = statusOptions.map((opt) => ({
    ...opt,
    count: statusCounts?.[opt.value] ?? 0,
  }));

  return (
    <div className="data-table">
      <DataTableMUI
        title="Payment Records"
        columns={PaymentColumns}
        data={payments || []}
        statusOptions={statusOptsWithCounts}
        statusFilter={statusFilter}
        onStatusFilterChange={handleStatusChange}
        pagination
        itemsPerPage={itemsPerPage}
        currentPage={pagination?.page || 1}
        totalItems={pagination?.total || 0}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
        searchable
        searchTerm={searchInput}
        setSearchTerm={setSearchInput}
        onSearch={handleSearch}
        loading={loading}
        sortKey={sortKey}
        sortOrder={sortOrder}
        onSort={handleSort}
      />
    </div>
  );
};

export default Payments;
